/**
 * @file: useConstructionWorkItemsFromInspectionResults.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { useCachedQuery } from '@euler/functions/useCachedQuery';
import { useServiceFactory } from '@euler/services/factory';

export function useConstructionWorkItemsFromInspectionResults() {
  const { taskService } = useServiceFactory();
  const { taskNo } = useTaskContext();
  const path = `tasks/${taskNo}/construction/work-items-from-inspection-results.json`;
  return useCachedQuery(path, 0, async () => {
    return await taskService.fetchConstructionWorkItems(taskNo);
  });
}
